import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/thanksgiving-day/2024/Index.vue')
const GreetingCardEdit = () => import('../activity/thanksgiving-day/2024/GreetingCardEdit.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/thanksgiving-day/2024',
  name: 'activity_thanksgiving_day_2024',
  component: Index,
  props: (_route) => ({ ..._route.query, ..._route.params }),
  meta: {
    title: 'S+宠粉感恩节',
  },
}

export const greetingCardEditRoute: RouteConfig = {
  path: '/activity/thanksgiving-day/2024/greeting-card-edit',
  name: 'activity_thanksgiving_day_2024_greeting_card_edit',
  component: GreetingCardEdit,
  props: (_route) => ({ ..._route.query, ..._route.params }),
  meta: {
    title: '定制贺卡',
  },
}

export default [indexRoute, greetingCardEditRoute]
